// DO NOT EDIT, GENERATED BY "yarn sheets"

import type { VendorRow } from '../typings';

const data = [
  {
    "hostname": "mizuno-apparels.cdev.orangelv.com",
    "environment": "staging",
    "sportId": "various",
    "vendorId": "mizuno",
    "orderMethod": "shopatron-cart",
    "orderEmail": "sublimated.orders@mizunousa.com",
    "orderEmailName": "MizunoUSA Sublimated orders",
    "shopatronId": "1661.4",
    "bakeryEmailTo": [
      "customizers@olv.global"
    ]
  },
  {
    "hostname": "uniforms.mizunocustom.com",
    "environment": "production",
    "sportId": "various",
    "vendorId": "mizuno",
    "orderMethod": "shopatron-cart",
    "orderEmail": "sublimated.orders@mizunousa.com",
    "orderEmailName": "MizunoUSA Sublimated orders",
    "shopatronId": "1661.4",
    "bakeryEmailTo": [
      "customizers@olv.global",
      "jon.george@mizunousa.com"
    ]
  }
] as const;

type Primitive = string | number | boolean | null | undefined;
type Immutable<T> = T extends Primitive
  ? T
  : { readonly [K in keyof T]: Immutable<T[K]> };

type Combine<T extends U, U> = T extends Readonly<Primitive | Primitive[]>
  ? T
  : T extends ReadonlyArray<infer I>
  ? Readonly<Combine<I, Extract<U, Readonly<any[]>>[number]>[]>
  : U extends Readonly<Primitive | any[]>
  ? never
  : string extends keyof U
  ? { [K in keyof T & string]: Combine<T[K], U[K]> }
  : number extends keyof U
  ? { [K in keyof T & number]: Combine<T[K], U[K]> }
  : symbol extends keyof U
  ? { [K in keyof T & symbol]: Combine<T[K], U[K]> }
  : { [K in keyof U]: Combine<T[K], U[K]> };

const typed: Combine<typeof data, Immutable<VendorRow[]>> = data;

export type Vendor = typeof typed[number];

export const VENDOR_INDEX_KEY = "hostname";
export type VendorIndexKey = "hostname";
export type VendorHostname = Vendor["hostname"];

let i = 0;
export const VENDOR_DICT = {
  "mizuno-apparels.cdev.orangelv.com": typed[i++],
  "uniforms.mizunocustom.com": typed[i++]
} as const;

export { typed as VENDORS };
